<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="tt1">学分管理与查询</div>
      <div class="tt2"
           v-if="info">剩余总学分{{info.sumScore}}分，为{{info.cardCount}}张面值{{info.score}}分的学分卡</div>
      <!-- <div class="tt2">国家级I类学分总数1000分/剩余800</div> -->
      <!-- <div class="tt2">省级II类学分总数1000分/剩余500</div> -->
    </div>
    <div class="top">
      <div class="tbox">
        <span class="tblabel">项目名称：</span>
        <el-select v-model="cid"
                   size="small"
                   @change="toUpdate"
                   placeholder="项目名称">
          <el-option v-for="item in cidoptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="tbox">
        <span class="tblabel">学习状态：</span>
        <el-select v-model="type"
                   size="small"
                   @change="toUpdate"
                   placeholder="学分匹配状态">
          <el-option v-for="item in typeoptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-input placeholder="请输入姓名/手机号/身份证号/单位"
                v-model="name"
                size="small"
                style="width:300px">
        <el-button slot="append"
                   @click="toUpdate"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="top2">
      <div></div>
      <div class="t2btn">
        <cmeLoad class="button"
                 :cid="cid"
                 @toLoadSucces="toUpdate"></cmeLoad>
        <!-- <el-button class="button"
                   type="primary"
                   size="small">兑换项目</el-button> -->
        <el-button class="button"
                   type="success"
                   @click="daochu"
                   size="small">一键导出</el-button>
      </div>
    </div>
    <div class="mid">
      <el-table ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                class="mtable"
                border>
        <!-- <el-table-column type="selection"
                         width="39"
                         style="text-align: center;">
        </el-table-column> -->
        <el-table-column prop="userName"
                         label="姓名"
                         width="80">
        </el-table-column>
        <el-table-column prop="mobile"
                         width="110"
                         label="手机号">
        </el-table-column>
        <el-table-column prop="iDcard"
                         width="170"
                         label="身份证号">
        </el-table-column>
        <el-table-column prop="natScore"
                         width="80"
                         label="剩余学分">
        </el-table-column>
        <el-table-column width="80"
                         label="学习时长">
          <template slot-scope="scope">{{ formatSeconds(scope.row.studyTime) }}</template>
        </el-table-column>
        <el-table-column label="学习状态"
                         width="80">
          <template slot-scope="scope">{{ scope.row.status==0?'未学完':scope.row.status==1?'已学完':'已考核' }}</template>
        </el-table-column>
        <el-table-column prop="unit"
                         width="240"
                         label="单位">
        </el-table-column>
        <el-table-column prop="mail"
                         width="160"
                         label="邮箱">
        </el-table-column>
        <el-table-column prop="bindDate"
                         width="160"
                         label="加入时间">
        </el-table-column>
      </el-table>
      <pagination v-if="page.total>page.pageSize"
                  isNum
                  :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange"></pagination>
    </div>

  </div>
</template>
<script>
import cmeLoad from '../../components/cmeLoad/index.vue';
import axios from 'axios';
export default {
  components: {
    cmeLoad
  },
  data () {
    return {
      storeName: '',
      page: {
        total: 0,
        pageSize: 8,
        currentPage: 1
      },
      info: null,
      cid: '',
      cidoptions: [],
      list: [],
      typeoptions: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '未学完'
      }, {
        value: 2,
        label: '已学完'
      }, {
        value: 3,
        label: '已考核'
      }],
      type: 0,
      name: ''
    }
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getInfo()
    this.getCourseList()
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
      this.getList()
    },
    toUpdate () {
      this.page.currentPage = 1
      this.getList()
    },
    getInfo () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgCardConfigById', {
          orgId: this.orgid
        })
        .then(res => {
          if (res.code == 200) {
            this.info = res.data
          }
        })
    },
    getList () {
      this.httphelper
        .post('/api/LearnProjectApi/GetLearnProUserPageList', {
          orgId: this.orgid,
          cid: this.cid,
          status: this.type,
          userName: this.name,
          page: this.page.currentPage,
          limit: this.page.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.page.total = res.data.totalcount
            this.list = res.data.data
          }
        })
    },
    getCourseList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgLearProjectList', {
          orgId: this.orgid,
          type: 0
        })
        .then(res => {
          if (res.code == 200) {
            for (let i = 0; i < res.data.length; i++) {
              if (i == 0) {
                if (this.$route.query.cid) {
                  this.cid = this.$route.query.cid
                } else {
                  this.cid = res.data[i].cid
                }
              }
              this.cidoptions.push({
                value: res.data[i].cid,
                label: res.data[i].pname
              })
            }
            this.getList()
          }
        })
    },
    formatSeconds (value) {
      if (value == 0) return 0
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));
      result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
      result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;
      return result;
    },
    daochu () {
      axios({
        // 用axios发送post请求
        method: "post",
        url: "/api/LearnProjectApi/DeriveLearnProUserExcel", // 请求地址 ，也可以传递参数
        data: {
          orgId: this.orgid,
          cid: this.cid,
          status: this.type,
          userName: this.name
        },
        responseType: "blob" // 表明返回服务器返回的数据类型
      }).then(res => {
        // 处理返回的文件流
        //主要是将返回的data数据通过blob保存成文件
        var content = res.data;
        var blob = new Blob([content]);
        var fileName = "CME课程成员学习情况.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          // 非IE下载
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });

    }
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    margin: 30px 0 30px 0;
    display: flex;
    align-items: center;
    line-height: 56px;
    .tt1 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0b8586;
    }
    .tt2 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        margin-left: 36px;
    }
}
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .tbox {
        align-items: center;
        .tblabel {
            font-size: 14px;
        }
    }
}
.top2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .t2btn {
        .button {
            margin-left: 30px;
            display: inline-block;
        }
    }
}
.mid {
    .mtable {
        width: 973px;
        ::v-deep thead {
            th {
                background-color: #0b8586 !important;
                color: #fff;
            }
        }
    }
}
</style>
